import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8261ea30"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _createTextVNode(" 消息 ");
const _hoisted_2 = { class: "message_container" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "notify" }, "站内消息通知", -1));
const _hoisted_4 = { class: "message_list" };
import { readMessage } from "@/service/message";
import { getMsg } from "@/utils";
import { computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import MessageList from "./MessageList.vue";
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    props: {
        unReadCount: { default: 0 }
    },
    emits: ["readMessage"],
    setup(__props, { emit }) {
        const props = __props;
        const route = useRoute();
        // 路由跳转
        const router = useRouter();
        const messageDrop = ref();
        const messageListRef = ref();
        const seeMessage = () => {
            router.push("/message/index");
            messageDrop.value.handleClose();
        };
        const goDetail = () => {
            emit("readMessage");
            messageDrop.value.handleClose();
        };
        const messageActive = computed(() => {
            return route.matched[0].name === "message";
        });
        const visible = ref(false);
        const readAll = async () => {
            await readMessage({ is_all: 1 });
            emit("readMessage");
            await messageListRef.value?.loadMessageList();
            getMsg("全部已读");
            messageDrop.value.handleClose();
        };
        // 下拉框显示/隐藏时的回调
        const handleVisibleChange = async (val) => {
            visible.value = val;
            if (val) {
                await messageListRef.value?.loadMessageList();
            }
        };
        return (_ctx, _cache) => {
            const _component_el_dropdown = _resolveComponent("el-dropdown");
            return (_openBlock(), _createBlock(_component_el_dropdown, {
                ref_key: "messageDrop",
                ref: messageDrop,
                offset: 0,
                trigger: "click",
                "popper-options": {
                    modifiers: [{ name: 'offset', options: { offset: [0, 20] } }]
                },
                class: "dropdown_container",
                "popper-class": "my-dropdown-popper-arrow",
                onVisibleChange: handleVisibleChange
            }, {
                dropdown: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", { class: "top_bar" }, [
                            _hoisted_3,
                            _createElementVNode("div", null, [
                                _createElementVNode("span", {
                                    class: "top_bar-right ele-hover",
                                    onClick: readAll
                                }, "全部已读")
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(MessageList, {
                                ref_key: "messageListRef",
                                ref: messageListRef,
                                onListClick: goDetail
                            }, null, 512)
                        ])
                    ]),
                    _createElementVNode("div", {
                        class: "more ele-hover",
                        onClick: seeMessage
                    }, "查看全部")
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        class: _normalizeClass([
                            'menu-item display-flex align-items',
                            _unref(messageActive) || visible.value ? 'active' : ''
                        ])
                    }, [
                        _hoisted_1,
                        (props.unReadCount)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(['badge', Number(props.unReadCount) < 10 ? 'readCount' : ''])
                            }, _toDisplayString(props.unReadCount), 3))
                            : _createCommentVNode("", true)
                    ], 2)
                ]),
                _: 1
            }, 512));
        };
    }
});
